<template>
  <div class="position-relative">
    <span
      class="placeholder-container py-2 cursor-pointer"
      @click="showPlaceholderContainer()"
    >
      {{ questionPlaceholderValue }}
    </span>
    <transition name="fade">
      <div
        v-click-outside="onClickOutside"
        class="control-placeholder position-absolute p-2"
        v-if="showPlaceholderPopup"
      >
        <div class="row text-name-container mb-3 px-3 w-100 g-0">
          <input
            type="text"
            class="text-name-input d-block py-2 col-10"
            value=""
            v-model="inputValue"
            placeholder="Placeholder Name"
          />

          <div class="col-2 d-flex justify-content-end align-items-center">
            <div
              class="
                add-new-placeholder
                cursor-pointer
                d-flex
                justify-content-center
                align-items-center
                rounded-circle
              "
              @click="
                addPlaceholder(inputValue);
                setValueToPlaceholder(inputValue);
              "
            >
              +
            </div>
          </div>
        </div>
        <div class="px-3">
          <p class="label mb-1">Select from placeholder list</p>
          <ul class="brand-list overflow-auto mx-0 my-2 list-unstyled">
            <li
              class="d-flex align-items-center"
              v-for="(placeholder, index) in allPlaceholderValues"
              :key="'placeholder-' + placeholder + index"
            >
              <label
                :for="'option' + index + questionIndex"
                class="
                  d-flex
                  align-items-center
                  py-2
                  text-capitalize
                  w-100
                  cursor-pointer
                "
              >
                <input
                  type="radio"
                  :id="'option' + index + questionIndex"
                  :name="'brands' + questionIndex"
                  :value="placeholder"
                  class="filter-option me-2 cursor-pointer"
                  v-model="selectedPlaceholder"
                />
                {{ placeholder }}
              </label>
            </li>
          </ul>
        </div>
        <div
          v-if="allPlaceholder.length > 1"
          class="m-2 row apply-all align-items-center"
        >
          <p class="apply-all-text py-3 col-6 m-0">Apply to all fields</p>
          <div
            @click="applyAllToggle = !applyAllToggle"
            class="toggle-circle px-1 ms-auto col-6 cursor-pointer"
            :class="{ 'toggle-circle-active': applyAllToggle }"
          >
            <div class="rounded-circle circle"></div>
          </div>
        </div>
        <div class="row mt-3 g-0">
          <div class="col-6">
            <button
              class="px-5 text-capitalize pt-1 pb-2 cancel-btn popup-btn"
              @click="
                showPlaceholderPopup = false;
                applyAllToggle = false;
                closeFlag = !closeFlag;
              "
            >
              Cancel
            </button>
          </div>
          <div class="col-6">
            <button
              class="px-5 apply-btn text-capitalize pt-1 pb-2 popup-btn"
              @click="selectPlaceholder()"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import PlaceholderManager from "@/manager/placeholderManager";

export default {
  name: "Placeholder",

  props: {
    question: {
      type: String,
      required: true,
    },
    questionIndex: {
      type: Number,
      required: true,
    },
  },

  inject: [
    "allPlaceholders",
    "applyPlaceholder",
    "allPlaceholderKey",
    "placeholderValues",
    "addPlaceholder",
  ],
  data() {
    return {
      applyAllToggle: false,
      showPlaceholderPopup: false,
      inputValue: "",
      selectedPlaceholder: "",
      closeFlag: false,
    };
  },
  computed: {
    questionPlaceholderKey() {
      return PlaceholderManager.questionPlaceholderKey(this.question);
    },
    allPlaceholder() {
      return this.allPlaceholders();
    },
    allPlaceholderKeys() {
      return this.allPlaceholderKey();
    },
    allPlaceholderValues() {
      return this.placeholderValues();
    },
    questionPlaceholderValue() {
      return PlaceholderManager.questionPlaceholderValue(
        this.allPlaceholder,
        this.questionPlaceholderKey
      );
    },
  },
  methods: {
    showPlaceholderContainer() {
      this.selectedPlaceholder = this.questionPlaceholderValue;
      this.showPlaceholderPopup = true;
    },
    selectPlaceholder() {
      this.applyPlaceholder(
        `${this.applyAllToggle ? "all" : "one"}`,
        this.questionPlaceholderKey,
        this.selectedPlaceholder
      );
      if (!this.applyAllToggle) {
        const newPlaceholderObject = {
          locale: "EN",
          placeholder: this.questionPlaceholderKey,
          value: this.selectedPlaceholder,
        };
        this.$store.dispatch("surveyJourney/changeOnePlaceholder", {
          newPlaceholderObject,
        });
      } else {
        this.$store.dispatch("surveyJourney/changeAllPlaceholder", {
          allPlaceholderKeys: this.allPlaceholderKeys,
          selectedPlaceholder: this.selectedPlaceholder,
        });
        this.applyAllToggle = false;
      }
      this.showPlaceholderPopup = false;
      this.closeFlag = !this.closeFlag;
    },

    onClickOutside() {
      if (this.closeFlag) {
        this.showPlaceholderPopup = false;
      }
      this.closeFlag = !this.closeFlag;
    },
    setValueToPlaceholder(addedPlaceholder) {
      if (addedPlaceholder !== "") {
        this.selectedPlaceholder = addedPlaceholder;
      }
    },
  },
  mounted() {
    this.selectedPlaceholder = this.questionPlaceholderValue;
  },
};
</script>

<style lang="scss" scoped>
%radius-44_transition-400 {
  border-radius: $radius-44;
  transition: $transition-400ms;
}

.placeholder-container {
  border: $border-white-1;
  padding-left: 2rem;
  padding-right: 2rem;
  @extend %radius-44_transition-400;

  &:hover {
    background-color: $color-white;
    color: $color-grey-100;
  }
}

.control-placeholder {
  width: 337px;
  height: 338px;
  z-index: 6;
  left: 0;
  top: -10px;
  background-color: $color-white;
  border: $border-white-1;
  border-radius: $radius-25;
}

.text-name-container {
  border-radius: $radius-44;
  background-color: $color-grey-20;
}

.text-name-input {
  outline: unset;
  border: 0;
  background-color: unset;
  text-align: left;
  @extend %font-16-regular;
  color: $color-grey-100;
}

.add-new-placeholder {
  width: 25px;
  height: 25px;
  background-color: $color-white;
  color: $color-grey-60;
  font-size: $font-size-24;
  font-family: initial;
  border: $border-grey-60;
}

.brand-list {
  max-height: 120px;

  li {
    @extend %font-16-regular;
    color: $color-grey-100;
  }
}

.label {
  color: #bebebe;
  @extend %font-18-semiBold;
}

.apply-all {
  border-top: $border-grey-1;
  border-bottom: $border-grey-1;
}

.apply-all-text {
  @extend %font-16-regular;
  color: $color-grey-100;
}

.toggle-circle {
  border: 1.5px solid $color-grey-60;
  border-radius: $radius-44;
  height: 30px;
  width: 60px;
  display: flex;
  align-items: center;
  transition: $transition-400ms;
  position: relative;

  .rounded-circle {
    transition: $transition-400ms;
    position: absolute;
    left: 5px;
  }
}

.circle {
  border: 1.5px solid $color-grey-60;
  width: 20px;
  height: 20px;
  background-color: $color-white;
}

.toggle-circle-active {
  background-color: $color-black;

  .rounded-circle {
    left: calc(100% - 1.5625rem);
  }
}

input[type="radio"] {
  width: 20px;
  height: 20px;
}

.apply-btn {
  border: $border-grey-60;

  &:hover {
    background-color: $color-grey-60;
  }
}

.cancel-btn {
  border: $border-white-1;
  background-color: $color-white;

  &:hover {
    background-color: $color-red-5;
    border: 1px solid $color-red-5;
  }
}

.popup-btn {
  @extend %radius-44_transition-400;

  &:hover {
    color: $color-white;
  }
}
</style>
